import React from "react";

interface FormFieldProps {
    label: string;
    value: string | number | undefined;
    onChange: (value: string) => void;
    type?: "text" | "number";
    colSize?: "col-4" | "col-6" | "col-8" | "col-12";
    placeholder?: string;
    floatingPoint: boolean;
}

export function FormField({
    label,
    value,
    onChange,
    type = "text",
    colSize = "col-4",
    placeholder,
    floatingPoint
}: FormFieldProps) {
    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
        const currentValue = e.target.value;

        if (floatingPoint) {
            // Replace comma with dot for floating point
            const normalizedValue = currentValue.replace(/,/g, '.');
            const parsed = parseFloat(normalizedValue);

            if (!isNaN(parsed)) {
                // Successfully parsed, update with normalized value
                onChange(normalizedValue);
            }
            // If parse error, keep current text (do nothing)
        } else {
            // Parse as integer
            const parsed = parseInt(currentValue);

            if (!isNaN(parsed)) {
                onChange(parsed.toString());
            } else {
                // On parse error, set to blank
                onChange('');
            }
        }
    };

    return (
        <div className={`${colSize} mb-3`}>
            <label className="fs-7 form-label fw-bolder text-gray-600">
                {label}
            </label>
            <input
                type={type}
                className="form-control form-control form-control-solid fs-7 p-2"
                value={value ?? ""}
                onChange={(e) => onChange(e.target.value)}
                onBlur={handleBlur}
                placeholder={placeholder}
            />
        </div>
    );
}
